import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AdminGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // Define patterns for public routes
    const publicRoutePatterns = [
      /^\/?institute\/[a-fA-F0-9]{24}\/questionnarie\/[a-fA-F0-9]{24}$/,  // Original public route
      /^\/?institute\/[a-fA-F0-9]{24}\/questionnarie-view-Table\/[a-fA-F0-9]{24}\/[0-9]+\/sendEmail\/[a-fA-F0-9]{24}$/  // sendEmail with institutionId
    ];
    // Check if current route matches any public pattern
    const isPublicRoute = publicRoutePatterns.some(pattern => pattern.test(state.url));
    if (isPublicRoute) {
      return true; // Allow public access
    }
    if (!user || Object.keys(user).length === 0) {
      this.router.navigate(['/auth/login']);
      return false;
    }
    return true; // Authenticated access
  }
}